import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UsersService } from '../../../services/crud/users.service';
import { FormGroup, FormBuilder, AbstractControl, Validators } from '@angular/forms';
import { AuthService } from '../../../services';
import { PasswordValidator } from '../../../validators/password-validator';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
 passwordForm: FormGroup;

  code;
  constructor(private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,

  ) { }
  ngOnInit(): void {
    this.passwordForm = this.formBuilder.group({
      password: [''],
      confirmPassword: [''],
    }, {
      validator: [PasswordValidator.MatchPassword, PasswordValidator.WeakPassword] // your validation method
    });

  }

  submit() {
    const id = this.route.snapshot.paramMap.get('id');
    const token =  this.route.snapshot.paramMap.get('token');
    this.authService.resetPassword(id, token, this.passwordForm.value.password)
      .subscribe(result => {
        this.router.navigate(['']);
      });
  }
}
